export default __webpack_public_path__ + "static/media/doc.fc50e6f4.svg";